import {Directive, ElementRef, OnInit} from '@angular/core';
import {NgControl} from "@angular/forms";
import {CsAutocompleteDirective} from "./cs-autocomplete.directive";

@Directive({
  selector: '[vssUiAutoCplControl]',
  exportAs: 'vssUiAutoCplControl'
})
export class CsAutoCplControlDirective implements OnInit{

  constructor(
    private control: NgControl,
    private autoCpl: CsAutocompleteDirective,
    private el: ElementRef
    ) { }
  ngOnInit() {
    this.autoCpl.selectItem.subscribe(
      e => {
        this.control.control?.setValue(e.item)
        setTimeout(() => {
          let ev = new KeyboardEvent('keyup');
          this.el.nativeElement.dispatchEvent(ev);
        }, 100)
      }
    )
  }
}
